import { useRoomCanMakeOnlineClass } from '$logic/hall/react-hook'
import { IconButton } from '@mui/material'
import { LiveIcon, MeetIcon } from '$common/icons'
import { RoomTypes } from '@weblite/ts-action/room'
import hostConf from '$config/frontend'

const hasCallOption = hostConf.HAS_CALL_OPTION
export function HallAppBarCallElement({
  roomId,
  onClick,
  roomType,
  background,
}: {
  roomId: string
  onClick: () => void
  roomType: Extract<RoomTypes, 'CHANNEL' | 'GROUP'>
  background?: string
}) {
  const { canMakeOnlineClass } = useRoomCanMakeOnlineClass(roomId)

  return canMakeOnlineClass || hasCallOption ? (
    <IconButton
      sx={{
        marginLeft: '4px',
      }}
      onClick={onClick}
    >
      {roomType === 'GROUP' ? (
        <MeetIcon sx={{ color: background ? 'neutral000' : 'neutral700' }} />
      ) : (
        <LiveIcon sx={{ color: background ? 'neutral000' : 'neutral700' }} />
      )}
    </IconButton>
  ) : null
}
